/** D-319 - month names for the approval texts ("נובמבר", "נובמבר 2026"). */
export function formatMonthName(month: string, lang: string = 'he'): string {
  const [y, m] = month.split('-').map(Number);
  if (!y || !m) return month;
  return new Date(y, m - 1, 15).toLocaleDateString(lang === 'he' ? 'he-IL' : 'en-GB', { month: 'long' });
}

export function formatMonthYear(month: string, lang: string = 'he'): string {
  const [y, m] = month.split('-').map(Number);
  if (!y || !m) return month;
  return new Date(y, m - 1, 15).toLocaleDateString(lang === 'he' ? 'he-IL' : 'en-GB', { month: 'long', year: 'numeric' });
}
